// Database connection configuration for My App
// This file contains database connection settings

export const DATABASE_CONFIG = {
  host: "localhost",
  port: 3306,
  user: "root",
  password: "", // WAMP default - no password
  database: "nucleus", // Updated to use nucleus_gb_data
  charset: "utf8mb4",
};

// API base URL from environment variable
const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

// API endpoints for authentication
export const API_ENDPOINTS = {
    LOGIN: `${API_BASE}/auth/login`,
    USERS: `${API_BASE}/users`,
    ROLES: `${API_BASE}/roles`,
    HEALTH: `${API_BASE}/health`,
    PROFILE_UPDATE: `${API_BASE}/users`,
    PROFILE_PHOTO_UPLOAD: `${API_BASE}/users`,
    PROFILE_PHOTO_REMOVE: `${API_BASE}/users`
};

// Database table names
export const TABLES = {
  USERS: "users",
  ROLES: "roles",
} as const;





